module.exports = __webpack_public_path__ + "img/back.6b8fbfcd.svg";